/* eslint-disable @typescript-eslint/ban-ts-comment */
import {AxiosResponse} from "axios";
import {BatchOperationRequest, CoreTaskQueue, CoreValidationResponse, Filter} from "@mm-products/java-multima-framework";
import {taxGuruAxios} from "../axios";
import {documentUrls} from "../url";
import {TaxDocumentResult} from "../models/TaxDocumentResult";
import {TaxDocumentUploadRequest} from "../models/TaxDocumentUploadRequest";
import {TaxDocumentDto} from "../models/TaxDocumentDto";
import {TaxDocumentRequest} from "../models/TaxDocumentRequest";
import {ExportTypeFormatParams} from "../../../modules/document/component/batch/DocumentExportButton";

export const createByAttachments = (request: TaxDocumentUploadRequest, toastId?: string): Promise<AxiosResponse<TaxDocumentDto>> => {
    return taxGuruAxios.post(documentUrls.createByAttachments, request, {
        // @ts-ignore
        toastId,
    });
};

export const listDocuments = (filter: Filter, signal?: AbortSignal, toastId?: string): Promise<AxiosResponse<TaxDocumentResult>> => {
    return taxGuruAxios.post(documentUrls.filter, filter, {
        signal,
        // @ts-ignore
        toastId,
    });
};

export const changeDocumentState = (
    taxDocumentId: string,
    desiredStatus?: TaxDocumentDto.status,
    comment?: string,
    signal?: AbortSignal,
    toastId?: string
): Promise<AxiosResponse<void>> => {
    return taxGuruAxios.post(documentUrls.changeStatus(encodeURIComponent(taxDocumentId)), {note: comment}, {
        headers: { "Content-Type": "application/json" },
        signal,
        params: {
            desiredStatus,
        },
        // @ts-ignore
        toastId,
    });
};

export const getDocument = (taxDocumentId: string, toastId?: string, signal?: AbortSignal, noErrorToast?: boolean): Promise<TaxDocumentDto> => {
    return taxGuruAxios
        .get(documentUrls.get(encodeURIComponent(taxDocumentId)), {
            // @ts-ignore
            toastId,
            signal,
            noErrorToast,
        })
        .then((data) => data.data);
};

export const roundItemsOnDocument = (
    taxDocumentId: string,
    direction: "up" | "down",
    toastId?: string,
    signal?: AbortSignal,
    noErrorToast?: boolean
): Promise<void> => {
    return taxGuruAxios
        .post(documentUrls.roundItems(encodeURIComponent(taxDocumentId)), undefined, {
            // @ts-ignore
            toastId,
            signal,
            noErrorToast,
            params: {
                direction: direction.toUpperCase(),
            },
        })
        .then((data) => data.data);
};

export const reRunRecogniserTask = (taxDocumentId: string, toastId?: string): Promise<void> => {
    return taxGuruAxios
        .put(documentUrls.reRunRecogniserTask(encodeURIComponent(taxDocumentId)), undefined, {
            // @ts-ignore
            toastId,
        })
        .then((data) => data.data);
};

export const validateDocumentBeforeConfirm = (
    documentId: string,
    doc: TaxDocumentRequest,
    toastId?: string
): Promise<AxiosResponse<CoreValidationResponse>> => {
    return taxGuruAxios.post(documentUrls.validateOnConfirm(encodeURIComponent(documentId)), doc, {
        // @ts-ignore
        toastId,
    });
};

export const validateDocumentBeforeFinishCorrection = (
    documentId: string,
    doc: TaxDocumentRequest,
    toastId?: string
): Promise<AxiosResponse<CoreValidationResponse>> => {
    return taxGuruAxios.post(documentUrls.validateOnFinishCorrection(encodeURIComponent(documentId)), doc, {
        // @ts-ignore
        toastId,
    });
};

export const validateDocumentBeforeSave = (
    documentId: string,
    doc: TaxDocumentRequest,
    toastId?: string
): Promise<AxiosResponse<CoreValidationResponse>> => {
    return taxGuruAxios.post(documentUrls.validateOnSave(encodeURIComponent(documentId)), doc, {
        // @ts-ignore
        toastId,
    });
};

export const saveExtractedDocument = (documentId: string, doc: TaxDocumentRequest, toastId?: string): Promise<AxiosResponse<TaxDocumentDto>> => {
    return taxGuruAxios.post(documentUrls.saveExtracted(encodeURIComponent(documentId)), doc, {
        // @ts-ignore
        toastId,
    });
};

export const confirmDocument = (documentId: string, doc: TaxDocumentRequest, toastId?: string): Promise<AxiosResponse<TaxDocumentDto>> => {
    return taxGuruAxios.post(documentUrls.confirmExtracted(encodeURIComponent(documentId)), doc, {
        // @ts-ignore
        toastId,
    });
};

export const deleteDocument = (taxDocumentId: string, toastId?: string): Promise<AxiosResponse<TaxDocumentDto>> => {
    return taxGuruAxios.delete(documentUrls.delete(encodeURIComponent(taxDocumentId)), {
        // @ts-ignore
        toastId,
    });
};

export const documentExport = (filter: Filter, exportTypeFormatParams: ExportTypeFormatParams, toastId?: string): Promise<CoreTaskQueue> => {
    return taxGuruAxios
        .post(documentUrls.export.export, filter, {
            // @ts-ignore
            toastId,
            params: {
                format: exportTypeFormatParams.exportFormat,
                type: exportTypeFormatParams.exportType,
            },
        })
        .then(({ data }) => data);
};

export const deleteExportTask = (jobId: string, toastId?: string) => {
    return taxGuruAxios.delete(documentUrls.export.delete(encodeURIComponent(jobId)), {
        // @ts-ignore
        toastId,
    });
};

export const updateDocument = (taxDocumentId: string, req: TaxDocumentRequest, toastId?: string): Promise<AxiosResponse<TaxDocumentDto>> => {
    return taxGuruAxios.put(documentUrls.update(encodeURIComponent(taxDocumentId)), req, {
        // @ts-ignore
        toastId,
    });
};

export const downloadISDOC = (taxDocumentId: string, toastId?: string): Promise<AxiosResponse<Blob>> => {
    return taxGuruAxios.get(documentUrls.downloadIsdoc(encodeURIComponent(taxDocumentId)), {
        // @ts-ignore
        toastId,
        responseType: "blob",
    });
};

export const documentExportCount = (filter: Filter, type: TaxDocumentDto.exportType, toastId?: string): Promise<number> => {
    return taxGuruAxios
        .post(documentUrls.export.count, filter, {
            // @ts-ignore
            toastId,
            params: {
                type,
            },
        })
        .then((data: AxiosResponse<number>) => data.data);
};

export const documentBatchRequest = (request: BatchOperationRequest, toastId?: string): Promise<CoreTaskQueue> =>
    taxGuruAxios
        .post(documentUrls.batch, request, {
            // @ts-ignore
            toastId,
        })
        .then(({ data }) => data);

export const listPaymentMeans = () => {
    return taxGuruAxios.get(documentUrls.getPaymentMeans).then(({ data }) => data);
};
export const integrationRequestBody = (id: string): Promise<object> => {
    return taxGuruAxios.get(documentUrls.integrationRequest(encodeURIComponent(id))).then(({ data }) => data);
};

export const documentClassifications = (type?: Required<TaxDocumentDto["type"]>): Promise<Array<TaxDocumentDto.classification>> => {
    if (type === undefined) {
        return taxGuruAxios.get(documentUrls.classifications).then(({ data }) => data);
    }
    return taxGuruAxios.get(documentUrls.classifications, { params: { type } }).then(({ data }) => data);
};

export const approveDocument = (taxDocumentId: string, comment?: string, signal?: AbortSignal, toastId?: string): Promise<AxiosResponse<void>> => {
    return taxGuruAxios.post(documentUrls.approve(encodeURIComponent(taxDocumentId)), {note: comment}, {
        headers: { "Content-Type": "application/json" },
        signal,
        // @ts-ignore
        toastId,
    });
};

export const disapproveDocument = (taxDocumentId: string, comment?: string, signal?: AbortSignal, toastId?: string): Promise<AxiosResponse<void>> => {
    return taxGuruAxios.post(documentUrls.disapprove(encodeURIComponent(taxDocumentId)), {note: comment}, {
        headers: { "Content-Type": "application/json" },
        signal,
        // @ts-ignore
        toastId,
    });
};
